export default class Accordion {
  constructor() {
    this.accordions = [];
    this.moreTextSections = [];
    this.init();
  }

  init() {
    this.accordions = document.querySelectorAll('.js-accordion');
    this.moreTextSections = document.querySelectorAll('.js-more-text');
    this.setupAccordionListeners();
    this.setupMoreTextListeners();
  }

  // アコーディオン処理
  setupAccordionListeners() {
    this.accordions.forEach(accordion => {
      const btn = accordion.firstElementChild;
      const content = accordion.querySelector('.js-accordion__content');

      btn.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');

      btn.addEventListener('click', () => this.toggleAccordion(accordion));
    });
  }

  toggleAccordion(clicked) {
    const btn = clicked.firstElementChild;
    const content = clicked.querySelector('.js-accordion__content');
    const isActive = clicked.classList.contains('is-active');

    if (isActive) {
      clicked.classList.remove('is-active');
      btn.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
      content.style.maxHeight = null;
    } else {
      clicked.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      content.style.maxHeight = `${content.scrollHeight}px`;
    }
  }

  // 「もっと見る」処理 (.js-more-content を表示)
  setupMoreTextListeners() {
    this.moreTextSections.forEach(section => {
      const trigger = section.querySelector('.js-more-trigger');
      const content = section.querySelector('.js-more-content');

      if (trigger && content) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();

          // トリガーをフェードアウト
          trigger.style.transition = 'opacity 0.3s ease';
          trigger.style.opacity = '0';
          setTimeout(() => {
            trigger.style.display = 'none';
          }, 300);

          // コンテンツをスライドダウン
          content.style.display = 'block';
          content.style.maxHeight = '0';
          content.style.overflow = 'hidden';
          content.style.transition = 'max-height 0.5s ease';

          const height = content.scrollHeight;
          requestAnimationFrame(() => {
            content.style.maxHeight = `${height}px`;
          });
        });
      }
    });
  }
}
